import axios from 'axios';

// Bump when the tour changes materially enough that already-onboarded users
// should see it again. The completion row in D1 stores the version that was
// completed. (Re-onboarding on bump isn't wired up yet — any stored completion
// suppresses the tour — but persisting the version keeps that option open.)
// v2 = interactive spotlight tour (replaced the full-screen walkthrough modal).
export const ONBOARDING_VERSION = '2';

// Thin client for the per-user onboarding state. The backend derives the user
// from the OIDC session and proxies to the worker/D1 — the frontend never
// sends a user id.

/**
 * Returns true if the current user has already completed (or skipped) the
 * first-login walkthrough. Fails SAFE: on any error we report `true` so a
 * backend/D1 hiccup can never trap the user behind the tour on every load.
 */
export async function fetchOnboardingCompleted(): Promise<boolean> {
  try {
    const resp = await axios.get('/api/onboarding', { withCredentials: true });
    return !!resp.data?.completed;
  } catch {
    return true;
  }
}

/** Records that the current user finished or skipped the walkthrough. Best-effort. */
export async function markOnboardingComplete(): Promise<void> {
  try {
    await axios.post(
      '/api/onboarding/complete',
      { version: ONBOARDING_VERSION },
      { withCredentials: true },
    );
  } catch {
    /* best-effort — the tour was already shown; a failed write only risks showing it once more */
  }
}

/** Event other components dispatch to re-open the tour on demand (replay). */
export const REPLAY_ONBOARDING_EVENT = 'fsam:open-onboarding';
